export default "__VITE_ASSET__C5l7mRwJ__"